<div class="pend-detail-comments-container">
  <textarea maxlength="1000" class="commenttextarea" placeholder="Type here to reply." [(ngModel)]="commentText"></textarea>
  <div class="save-comment"><app-button (onClick)="saveComments()" text="SEND MESSAGE"></app-button></div>
  <app-comments [commentItems]="commentItems"></app-comments>
</div>
